<template>
  <div>
     <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->
    <!-- Form -->
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>          
          <v-container grid-list-md>
            <v-layout wrap>   

              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  label="Financial Year *"                  
                  v-model="formSchema.budgeting_year"
                  :items="BudgetingYearList"
                  :rules="[v => !!v || 'Financial year is required !']"
                  @input="checkFinancialYear(formSchema.budgeting_year)"
                  required
                ></v-autocomplete>
              </v-flex>   

              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  label="Budget Category *"
                  v-model="formSchema.budget_category"
                  :items="rootNameList"
                  :rules="[v => !!v || 'Budget category is required !']"
                  @input="checkFinancialYear(formSchema.budget_category)"
                  required
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md4>                
                <DatePicker
                  :key="formSchema.id"
                  :inputData="{index:1,fieldName:'start_date', fieldValue:formSchema.start_date, label:'Start Date *',required:'1'}"
                  @setValue="setDateValue"
                ></DatePicker>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <DatePicker
                  :key="formSchema.id"
                  :inputData="{index:2,fieldName:'end_date', fieldValue:formSchema.end_date, label:'End Date *',required:'1', disabled:'1'}"
                  ref="setRange"
                  @setValue="setDateValue"
                ></DatePicker>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Related Document"
                  v-model="formSchema.document_name"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                File
                <input
                  type="file"
                  id="files2"
                  ref="image2"
                  v-on:change="handleFilesUpload()"
                />
              </v-flex>

              <v-flex xs12 sm6 md6 v-if="formSchema.revision>0">
                <v-textarea label="Remarks" v-model="formSchema.remarks">></v-textarea>
              </v-flex>

              <v-flex xs12 sm6 md4 >
                <v-checkbox v-model="formSchema.is_active" label="Active" :value="is_activeVal"></v-checkbox>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
            <v-icon>save</v-icon>
            {{addUpdateBtn}}
          </v-btn>
          <v-btn color="error" @click.native="$refs.form.reset" @click="resetForm">
            <v-icon>refresh</v-icon>Reset
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");
let utilities = require("../../../utilities/utilities");
import DatePicker from "../../global/date_picker";

export default {
  props: ["formSchema"],
  components: {
    DatePicker
  },
  data: () => ({
    valid: true,
    is_activeVal:1,
    documentFiles: [],
    BudgetingYearList: utilities.getBudgetingYearList(),
    rootNameList: utilities.getRootNameList(),
    
    SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0 ? 
      this.formSchema.revision > 0 ? "Revision Yearly Project Budget (ADP & Non-ADP)" : 
      "Edit Yearly Project Budget (ADP & Non-ADP)" : 
      "Add Yearly Project Budget (ADP & Non-ADP)";
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? this.formSchema.revision > 0 ? "Revision" : "Update" : "Save";
    }
  },

  created() {
    // commonService.getAllData("operation-activities").then(res => {
    //   if (res.status == "success") {
    //     this.projectList = res.data;
    //   }
    // });    
  },

  methods: {
    setDateValue(data) {
      let index = data.index
      this.formSchema[data.fieldName] = data.value;

      if(data.fieldName == "start_date"){
        this.formSchema.end_date = 0
        this.$refs.setRange.setRange(data.value);
      }
    },

    validateBeforeSubmit(e) {
      
      let formData = new FormData();
      var formSchema = this.formSchema;

      /*if ((this.documentFiles.length == 0 ) && (this.formSchema.upload_file_name == "")) {
        this.close({ message: "You don't select any file!", status: 0 });
        return false;
      }*/

      if (this.$refs.form.validate()) {

        formSchema.start_date = this.changeFormateYMD(
          formSchema.start_date
        );

        formSchema.end_date = this.changeFormateYMD(
          formSchema.end_date
        );

        let formData = new FormData();

        for (var i = 0; i < this.documentFiles.length; i++) {
          let file = this.documentFiles[i];
          formData.append("files[" + i + "]", file);
        }

        formSchema.record_id = sessionStorage.getItem("mm_id");
        formSchema.sub_menu_id = sessionStorage.getItem("sm_id");

        formData.append("fieldValues", JSON.stringify(formSchema));

        commonService.insertFormData(formData, "yearly-project-budget").then(res => {
          let actionData = {
            message: res.message,
            data: res.data,
            action: res.action,
            status: res.status
          };

          if (res.status == 1) {
            this.$refs.form.reset();
            this.formSchema.id = 0;
            this.formSchema.start_date = ''
            this.formSchema.end_date = ''
          }
          this.close(actionData);
        });
      }
    },

    handleFilesUpload() {
      let uploadedFiles = this.$refs.image2.files;
      let fileExtension = uploadedFiles[0].name.replace(/^.*\./, "");
      //console.log("uploadedFiles", uploadedFiles);

      let allowedExtensions = /(\.jpg|\.JPG|\.jpeg|\.JPEG|\.png|\.PNG|\.pdf|\.doc|\.docx|\.doc)$/i;
      if (!allowedExtensions.exec(uploadedFiles[0].name)) {
        
        this.SnackbarVal.message = "You can upload jpg, jpeg, png, pdf, doc and docx file only";
        this.SnackbarVal.snackbar = true;
        this.SnackbarVal.color = 'error';

        this.$refs.image2.value = "";
        this.documentFiles = [];
      } else {
        for (var i = 0; i < uploadedFiles.length; i++) {
          this.documentFiles.push(uploadedFiles[i]);
        }
      }
    },

    checkFinancialYear(fYear){

      let pro_val = {
        'fYear':this.formSchema.budgeting_year,
        'budget_category':this.formSchema.budget_category
        }
      commonService.dataByMulParameters(pro_val,"check-budgeting-year-exist").then(res => {
        if(res.count > 0)
        {
          this.formSchema.budget_category = '';
          this.formSchema.budgeting_year='';
          this.SnackbarVal.color = "error"; 
          this.SnackbarVal.message = "Same financial year & budget category already exist"
          this.SnackbarVal.snackbar = true;
        }
      });
    },
    
    resetForm(){
      this.formSchema.id = 0;      
    },

    close: function(data) {      
      this.documentFiles = [];
      document.getElementById("files2").value = null;
      this.$emit("emitForm", data);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/project_info/yearly_project_budget/insertForm.vue